import React, { Component, createRef } from "react";

import { Spinner } from "../../Components/Spinner/Spinner";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { getPlainToken, getUserData } from "../../assets/Js/tokenHandler";

import { isObjectEmpty } from "../../assets/Js/isObjectEmpty";

import style from "./ViewScore.module.css";
import CommentList from "../CommentList/CommentList";
import GifsandStickers from "../../Components/GifsandStickers/GifsandStrickers";
import gifTypes from "../../assets/Js/gifTypes";

import UnitEnum from "../../assets/Js/UnitEnum";
import { ScoreTypeLabel } from "../../assets/Js/scoreEnum";
import ReactLinkify from "react-linkify";
import { LikesList } from "./LikesList";
import { ScoreCard } from "./ScoreCard";
import parseJwt from "../../assets/Js/jwtParse";

const initialState = {
  isLoading: false,
  showDetails: 0,
  didLike: false,
  showUsersWhoLiked: false,
  selectedScoreId: null,
  scoreDetails: {},
  scoreData: [],
  numberOfLikes: 0,
  numberOfComments: 0,
  localComments: [],
  notes: "",
  comment: "",
  scoreType: "",
  selectedUser: "",
  selectedGif: null,
  currentUserId: "",
  whichType: "",
  disableComment: false,
  scoreVideo: "",
  WeightPreference: UnitEnum.lbs,
};
export default class ViewScore extends Component {
  constructor(props) {
    super(props);

    this.commentRef = createRef();

    this.state = initialState;
  }

  componentDidMount() {
    let tokenObject = parseJwt(getPlainToken());
    this.setState({
      currentUserId: tokenObject.name,
    });
    if (this.props.trackWorkoutId) {
      this.getScore();
    }
  }

  static getDrivedStateFromProps(props, state) {
    return {
      ...state,
      showScore: props.showScore,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.defaultScoreDetails !== this.props.defaultScoreDetails) {
      this.setState({ showDetails: this.props.defaultScoreDetails });
    }

    if (this.props.showScore !== prevProps.showScore) {
      this.getScore();
    }

    if (this.state.selectedScoreId !== prevState.selectedScoreId) {
      this.getScoreDetails();
      if (this.state.selectedScoreId) {
        this.setState({
          showDetails: 1,
        });
      }
    }
  }

  getScore = async () => {
    let trackWorkoutId = this.props.trackWorkoutId;
    let url = `${projectSettings.baseUrl}/scores/viewscore/${trackWorkoutId}`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;

    let response = "";

    if (this.props && this.props.trackWorkoutId) {
      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.resetForRepen();

          this.setState({ scoreData: response.data });
          response = "";
        }
        this.setState({ isLoading: false });
      }
    }
  };

  getScoreDetails = async () => {
    let url = `${projectSettings.baseUrl}/scores/viewuserscoredetail/${this.state.selectedScoreId}`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;

    let response = "";

    if (response === "") {
      this.setState({ isLoading: true });
    }

    if (this.state.selectedScoreId) {
      response = await callAPI(url, header, type, data, token);

      if (response) {
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.setState({
            scoreDetails: response.data,
            numberOfLikes: response.data.likes,
            numberOfComments: response.data.comments.length,
            notes: response.data.notes,
            localComments: response.data.comments,
            didLike: response.data.hasliked,
            scoreType: response.data.scoretype,
            scoreVideo: response.data.videourl,
            WeightPreference: response.data.userPreferences.WeightPreference,
          });
          response = "";
        }
        this.setState({ isLoading: false });
      }
    }
  };

  renderScoreList = (scoreData) => {
    let { Gender, IsScaled, Scores } = scoreData;
    let scoreLength = scoreData.Scores?.length;

    if (Gender?.toLowerCase() === "male") {
      return (
        <>
          {IsScaled ? (
            <>
              <div className="lightHeading">Mex: Scaled Scores</div>
              {Scores.map((data) => (
                <ScoreCard
                  score={data}
                  handleScoreClick={this.handleScoreClick}
                  scoreType={this.props.scoreType}
                />
              ))}
            </>
          ) : (
            <>
              <div className="lightHeading">Men: Rx Scores</div>
              {Scores.map((data) => (
                <ScoreCard
                  score={data}
                  handleScoreClick={this.handleScoreClick}
                  scoreType={this.props.scoreType}
                />
              ))}
            </>
          )}
        </>
      );
    } else {
      return (
        <>
          {IsScaled ? (
            <>
              <div className="lightHeading">Women: Scaled Scores</div>
              {Scores.map((data) => (
                <ScoreCard
                  score={data}
                  handleScoreClick={this.handleScoreClick}
                  scoreType={this.props.scoreType}
                />
              ))}
            </>
          ) : (
            <>
              <div className="lightHeading">Women: Rx Scores</div>
              {Scores.map((data) => (
                <ScoreCard
                  score={data}
                  handleScoreClick={this.handleScoreClick}
                  scoreType={this.props.scoreType}
                />
              ))}
            </>
          )}
        </>
      );
    }
  };

  handleScoreClick = (score) => {
    this.setState({
      selectedScoreId: score.ScoreId,
      selectedUser: `${score.FirstName}  ${score.LastName}`,
    });
    this.props.forward(1);
  };

  likeClicked = async () => {
    let tempLike = this.state.didLike;
    let _loginUser = getUserData();
    if (!tempLike) {
      let _user = {
        Id: _loginUser.Id,
        FirstName: _loginUser.FirstName,
        LastName: _loginUser.LastName,
        image: _loginUser.Image,
      };
      let _scoreDetail = this.state.scoreDetails;
      if (!_scoreDetail.usersliked.some((item) => item.Id === _loginUser.Id)) {
        _scoreDetail.usersliked.unshift(_user);
        this.setState({
          scoreDetails: {..._scoreDetail},
        });
      }
    } else {
      let _scoreDetailFilter = this.state.scoreDetails;
      let _filterOutUser = _scoreDetailFilter.usersliked.filter(
        (item) => item.Id !== _loginUser.Id
      );
      _scoreDetailFilter.usersliked = _filterOutUser;
      this.setState({
        scoreDetails: {..._scoreDetailFilter},
      });
    }
    await this.setState({
      didLike: !tempLike,
      numberOfLikes: tempLike
        ? --this.state.numberOfLikes
        : ++this.state.numberOfLikes,
    });

    let url = `${projectSettings.baseUrl}/likes/save`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;

    let response = "";

    data = {
      scoreId: this.state.selectedScoreId,
      liked: this.state.didLike,
    };

    if (this.props && this.props.trackWorkoutId) {
      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        if (response.type === "error") {
        } else if (response.type === "success") {
          response = "";
        }
      }
    }
  };

  sendComment = async (e) => {
    e?.preventDefault();

    if (this.state.comment || this.state.selectedGif) {
      let url = `${projectSettings.baseUrl}/comments/save`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = null;

      let response = "";

      this.setState({ disableComment: true });

      data = {
        ScoreId: this.state.selectedScoreId,
      };

      if (this.state.selectedGif) {
        data.ImageUrl = this.state.selectedGif;
      } else {
        data.Comments = this.state.comment;
      }

      if (this.state.comment || this.state.selectedGif) {
        await this.setState({
          numberOfComments: ++this.state.numberOfComments,
        });

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          this.setState({ disableComment: false });

          this.setState({
            selectedGif: null,
            comment: null,
          });

          if (response.type === "error") {
          } else if (response.type === "success") {
            this.commentRef.current.value = "";
            await this.setState({
              localComments: [...this.state.localComments, response.data],
            });
            response = "";
          }
        }
      }
    }
  };

  sendGif = (data) => {
    this.setState(
      {
        selectedGif: data.images.original.url,
        whichType: null,
      },
      () => {
        this.sendComment();
      }
    );
  };

  labelToDiaply = () => {
    if (this.props.scoreType !== 0) {
      switch (this.state.scoreType) {
        case ScoreTypeLabel.Deadlift:
          return this.state.WeightPreference;
        case ScoreTypeLabel.ForComletion:
          return "";
        case ScoreTypeLabel.Weight:
          return this.state.WeightPreference;
        default:
          return this.state.scoreType;
      }
    }
  };

  openLikeModal = (e) => {
    e.stopPropagation();
    this.props.forward(2);

    this.setState({
      showUsersWhoLiked: true,
    });
  };

  closeLikeModal = (e) => {
    e.stopPropagation();

    this.setState({
      showUsersWhoLiked: false,
    });
  };

  renderDetialsPage = () => {
    return (
      <div className={`${style.detialsContainer} mb-5 ml-3 mr-3`}>
        {isObjectEmpty(this.state.scoreDetails) ? (
          <>
            <span>No Score Found</span>
          </>
        ) : (
          <>
            <div className={`${style.titleContainer} h6 text-center`}>
              {this.state.selectedUser}
            </div>
            {this.state.scoreDetails.values.map((data) => (
              <div
                className={`h6 pt-2 pb-2 mb-2 text-center colorMedium ${style.repsBox}`}
              >
                {this.props.scoreType === 0
                  ? data === "true"
                    ? "Completed"
                    : "Incomplete"
                  : data
                  ? data
                  : 0}
                <br />
                {this.labelToDiaply()}
              </div>
            ))}
            {this.state.scoreVideo && (
              <div>
                <div className="h6 mt-3">Score Video</div>
                <div>
                  <video
                    width="100%"
                    height="200px"
                    controls
                    className="objectFitContain"
                  >
                    <source
                      src={projectSettings.baseVideoUrl + this.state.scoreVideo}
                    ></source>
                    Your browser does not allow us to display video.
                  </video>
                </div>
              </div>
            )}
            <ReactLinkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              <div>
                <div className={`mt-3 mb-3`}>
                  <div className="h6">Notes</div>
                  <div className={style.notesBox}>
                    {this.state.notes ? this.state.notes : "No Notes"}
                  </div>
                </div>
              </div>
            </ReactLinkify>

            <div className="d-flex justify-content-between align-items-center border-bottom pt-2 pb-2">
              <div className="d-flex colorMedium align-items-center">
                <div
                  className={`mr-4 pointerCursor noHighLight ${
                    this.state.didLike && "primaryColor"
                  } ${style.infoTooltip}`}
                  onClick={this.likeClicked}
                >
                  <i className={`mdi mdi-thumb-up mr-2 h4`}></i>
                  <span className="mr-1">{this.state.numberOfLikes}</span>
                  Like
                  {this.state.numberOfLikes > 1 && "s"}
                  {this.state.numberOfLikes > 0 && (
                    <LikesList
                      likesInfo={this.state?.scoreDetails?.usersliked?.filter(
                        (item) => item.Id !== this.state.currentUserId
                      )}
                      personalLike={this.state.didLike}
                      userLimit={3}
                      hanldeBoxClick={this.openLikeModal}
                      listStyle={"mb-0 my-2"}
                      listContainerStyle={`${style.tooltiptext} primaryScrollBar tertiaryScrollBar shadow`}
                    />
                  )}
                </div>
                <div className="pointerCursor noHighLight">
                  <i className="mdi mdi-comment-text mr-2 h4"></i>
                  <span className="mr-1">{this.state.numberOfComments}</span>
                  Comment
                </div>
              </div>
            </div>

            <form
              className="d-flex align-items-center border-bottom pt-2 pb-2 mb-3"
              onSubmit={this.sendComment}
            >
              <span
                className="messageIcon gifIconStyle"
                onClick={() => {
                  this.commentRef.current.blur();
                  this.setState({ whichType: gifTypes.gif });
                }}
              >
                GIF
              </span>
              <span
                className="ml-2"
                onClick={() => {
                  this.commentRef.current.blur();
                  this.setState({ whichType: gifTypes.sticker });
                }}
              >
                <i className="mdi mdi-sticker messageIcon"></i>
              </span>
              <input
                type="text"
                className={style.commentBox}
                placeholder="Enter Comments Here ..."
                ref={this.commentRef}
                onFocus={() => {
                  this.setState({ whichType: null });
                }}
                onChange={(e) => this.setState({ comment: e.target.value })}
              />
              <div
                onClick={this.sendComment}
                className={`${
                  this.state.disableComment && "pointerEventsNone"
                }`}
              >
                <i
                  className={`mdi mdi-send h4 pointerCursor ${
                    !this.state.comment && "opacityLow"
                  }`}
                ></i>
              </div>
            </form>

            <GifsandStickers
              whichType={this.state.whichType}
              handleSelection={this.sendGif}
            />

            <div className="pb-3">
              <CommentList
                commentList={this.state.localComments}
                scoreId={this.state.selectedScoreId}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  resetForRepen = async () => {
    await this.setState(initialState);
    let tokenObject = parseJwt(getPlainToken());
    this.setState({
      currentUserId: tokenObject.name,
    });
  };

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
            <Spinner />
          </div>
        ) : !this.state.scoreData.length ? (
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5 h3">
            No Score Found
          </div>
        ) : (
          <>
            <div
              className={`${style.scoreContainer} mb-4 tertiaryScrollBar primaryScrollBar`}
            >
              {this.state.showDetails === 0 ? (
                this.state.scoreData.map((data) => this.renderScoreList(data))
              ) : this.state.showDetails === 1 ? (
                !isObjectEmpty(this.state.scoreDetails) &&
                this.renderDetialsPage()
              ) : this.state.showDetails === 2 ? (
                <LikesList
                  likesInfo={this.state?.scoreDetails?.usersliked}
                  personalLike={this.state.didLike}
                  showCard={true}
                  userLimit={this.state?.scoreDetails?.usersliked.length + 1}
                  listStyle={`listStyleTypeNone p-0 mx-3`}
                  cardStyle={"w-100 mt-3"}
                  imageStyle={"profileImage"}
                  txtStyle={"pl-3"}
                />
              ) : (
                <div className="text-center mt-5 mb-5">No Detials Found</div>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}
